import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './testimonial.css';
import TestimonialCard from './TestimonialCard';

const GOOGLE_BUSINESS_URL = 'https://share.google/5aOtJaFUppuISKAvF';

// ─────────────────────────────────────────────────────────────────────────────
// UPDATE THESE with your real Google reviews.
// Go to your Google Business page → copy reviewer name, date, and review text.
// avatarColor: '#4285F4' | '#34A853' | '#EA4335' | '#FBBC05'
// ─────────────────────────────────────────────────────────────────────────────
const AVERAGE_RATING = '4.8';
const TOTAL_REVIEWS  = '108';

const REVIEWS = [
  {
    name: 'Anamika Kaur',
    rating: 5,
    date: '2 days ago',
    description: 'Niks Cleaning did an amazing job with the spring cleaning of my house in Tarneit. Another company cancelled on me last minute, but Nik and the team stepped in and helped straight away. They were energetic, professional, and very hardworking throughout the whole job. Highly recommend Niks Cleaning for anyone looking for reliable cleaning services in Tarneit!',
    avatarColor: '#EA4335',
  },
  {
    name: 'tamkol 11',
    rating: 5,
    date: '3 days ago',
    description: 'I recently hired Niks Elite Cleaning for my end-of-lease cleaning, and I am extremely happy with the results. Their team delivered a highly professional service with outstanding attention to detail, ensuring the property was spotless and inspection-ready. They provided a full bond guarantee, and the real estate agency did not raise a single issue after the final inspection. The quality of their work, reliability, and professionalism truly exceeded my expectations.',
    avatarColor: '#EA4335',
  },
  {
    name: 'Neethu Jai',
    rating: 5,
    date: '4 weeks ago',
    description: 'We had a great experience with Niks Elite Cleaning for our end of lease clean. They offered a bond back guarantee, which gave us confidence from the start. He even handled key collection and return, which made things so much easier for us. Nik sorted everything without any hassle. Reliable, responsive, and true to his word. I\'d highly recommend Niks Elite Cleaning to anyone needing a stress-free end of lease clean.',
    avatarColor: '#4285F4',
  },
  {
    name: 'Venus Leung',
    rating: 5,
    date: '5 weeks ago',
    description: 'I had a fantastic experience with Niks Cleaning today! They did an incredibly thorough job, and the whole house is absolutely spotless. The communication was excellent, and the service was professional, punctual, and polite. It\'s such a relief to come home to such a clean space. Highly recommend their services to anyone looking for a reliable and high-quality cleaner!',
    avatarColor: '#EA4335',
  },
  {
    name: 'Marc Taylor',
    rating: 5,
    date: '6 weeks ago',
    description: 'Amazing professionalism. Such a pleasure to work with. Will be cleaning all my houses from now on. Thank you team. Highly recommend.',
    avatarColor: '#4285F4',
  },
  {
    name: 'Portia Holdman',
    rating: 5,
    date: '9 weeks ago',
    description: 'I messaged a few places needing a whole house done that week. Honestly Nik was the only one that got back to me in the same day!! They booked in straight away and the prices were amazing!! He had sent me photos of the results which I was very happy with. I was over the moon with the whole experience, I definitely recommend to other people!!',
    avatarColor: '#34A853',
  },
  {
    name: 'Brian Thomas',
    rating: 5,
    date: '12 weeks ago',
    description: 'Great service for the price. I booked my end of lease cleaning on the spot after cancellation from another company. They cooperated a lot with me. I would highly recommend them because of their professionalism.',
    avatarColor: '#FBBC05',
  },
  {
    name: 'Olivia Taylor',
    rating: 5,
    date: '17 weeks ago',
    description: 'Highly recommend Niks Elite Cleaning for end of lease cleaning. We had to travel overseas during our move, and they managed the entire process — from collecting the keys from the real estate agent to returning them after the clean. The bond cleaning was extremely detailed and inspection-ready. The property looked spotless, and the agent was very happy with the result. Professional, reliable, and trustworthy service.',
    avatarColor: '#34A853',
  },
  {
    name: 'Ti Sim Nguyen',
    rating: 5,
    date: '24 weeks ago',
    description: 'Nik was prompt with his arrival, efficient and very polite. My husband Charlie and I were very impressed with his professionalism and communication. From the first enquiry he was very responsive and friendly. When Nik would finish cleaning an area he would check with me first to see if it was to my standard before he moved onto the next area. He is a reliable, hardworking and well mannered young man. Thank you for your cleaning services Nik and we would definitely be using you again!',
    avatarColor: '#EA4335',
  },
  {
    name: 'E M',
    rating: 5,
    date: '25 weeks ago',
    description: 'Nick and a colleague cleaned my house when I sold it in Point Cook. Nick was extremely accommodating with my timeframe of me still moving out of the house and he still having to clean the house. I can highly recommend using Nick, you will not be disappointed.',
    avatarColor: '#4285F4',
  },
  {
    name: 'Knight Wang',
    rating: 5,
    date: '31 weeks ago',
    description: 'As a property agent, Nik is the best, most reasonably priced and most efficient cleaner we have ever worked with. They can complete the cleaning to a high standard within the time required by the landlord. Highly recommended!',
    avatarColor: '#34A853',
  },
];

const GoogleTextLogo = () => (
  <div className="google-text-logo" aria-label="Google">
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
    <span className="google-word-text">
      <span style={{ color: '#4285F4' }}>G</span>
      <span style={{ color: '#EA4335' }}>o</span>
      <span style={{ color: '#FBBC05' }}>o</span>
      <span style={{ color: '#4285F4' }}>g</span>
      <span style={{ color: '#34A853' }}>l</span>
      <span style={{ color: '#EA4335' }}>e</span>
    </span>
  </div>
);

export default function Testimonail() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-title">
        <h3 className="title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
          Testimonials
        </h3>
        <h2 className="sub-title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
          What Our Clients Say
        </h2>
      </div>

      <div className="google-widget-wrapper" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">

        <div className="google-widget-header">
          <div className="header-left">
            <GoogleTextLogo />
            <div className="header-stars">
              <span className="header-stars-icons">★★★★★</span>
              <span className="header-rating">{AVERAGE_RATING}</span>
              <span className="header-divider">|</span>
              <span className="header-label">Top Rated Service</span>
            </div>
          </div>
          <a
            href={GOOGLE_BUSINESS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="verified-badge"
          >
            <span className="verified-check-icon">✓</span>
            <span>Verified · {TOTAL_REVIEWS} Reviews</span>
          </a>
        </div>

        <div className="slider-wrapper">
          <button ref={prevRef} className="swiper-nav-btn swiper-nav-prev" aria-label="Previous">‹</button>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={16}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              640:  { slidesPerView: 2, spaceBetween: 16 },
              1024: { slidesPerView: 3, spaceBetween: 20 },
              1280: { slidesPerView: 4, spaceBetween: 20 },
            }}
            className="reviews-swiper"
          >
            {REVIEWS.map((review, i) => (
              <SwiperSlide key={i}>
                <TestimonialCard
                  name={review.name}
                  description={review.description}
                  rating={review.rating}
                  date={review.date}
                  avatarColor={review.avatarColor}
                  profilePhotoUrl={null}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <button ref={nextRef} className="swiper-nav-btn swiper-nav-next" aria-label="Next">›</button>
        </div>

      </div>
    </section>
  );
}
